import React from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';


//Redux
import { useSelector} from "react-redux";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: 10,
    color: '#fff',
    position: 'absolute'
  },
}));

export default function SimpleBackdrop() {
  const classes = useStyles();
  const { loading } = useSelector(state => state.ui);

  return (
    <div>
    
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
